import { render, staticRenderFns } from "./Donor.vue?vue&type=template&id=4589020e&scoped=true"
import script from "./Donor.vue?vue&type=script&lang=js"
export * from "./Donor.vue?vue&type=script&lang=js"
import style0 from "./Donor.vue?vue&type=style&index=0&id=4589020e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589020e",
  null
  
)

export default component.exports